module.exports = __webpack_public_path__ + "img/service-content-time@3x.565fde46.png";